import { requestBuilder } from '../../http/RequestBuilder';
import type {
    InterestNotificationRequestDto,
    InterestNotificationResponseDto,
} from './types';

export const useTriggerInterestNotifications = requestBuilder.mutation<
    InterestNotificationResponseDto,
    InterestNotificationRequestDto
>({
    endpoint: '/api/admin/bank-ops/interest-notifications/trigger',
    method: 'POST',
});
